module.exports = __webpack_public_path__ + "img/ai1.bce4ad59.png";